import React from 'react';
import { Carousel } from '@one-thd/sui-carousel';
import PropTypes from 'prop-types';
import { ListTile } from '@thd-olt-component-react/list-tile';
import classNames from 'classnames';

const ListCarousel = ({ lists, iconSize }) => {

  return (
    <div id="ListCarousel" data-testid="ListCarousel">
      <Carousel
        type="peek"
        layout="full-bleed"
        containerId="ListCarousel"
        slidesPerView="auto"
        slidesPerGroup={1}
        spaceBetween={0}
        breakpoints={{
          sm: { slidesPerGroup: 1, slidesPerView: 'auto' },
          md: { slidesPerGroup: 1, slidesPerView: 'auto' },
          lg: { slidesPerGroup: 1, slidesPerView: 'auto' },
          xl: { slidesPerGroup: 1, slidesPerView: 'auto' },
          '2xl': { slidesPerGroup: 1, slidesPerView: 'auto' },
        }}
        disableMargin
      >
        {lists?.map((list, index) => (
          <div
            key={index + list.id}
            className={
              classNames('sui-w-80 @xl:sui-w-96 @3xl:sui-w-96', {
                'sui-mr-4': index !== lists.length - 1,
              })
            }
          >
            <ListTile
              iconSize={iconSize}
              listId={list.id}
              onDelete={() => {}}
              data={list}
              numberOfThumbnails={2}
              enableSharedIcon
            />
          </div>
        ))}
      </Carousel>
    </div>
  );
};

ListCarousel.propTypes = {
  lists: PropTypes.arrayOf(PropTypes.shape({
    href: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  })).isRequired,
  iconSize: PropTypes.string,
};

ListCarousel.defaultProps = {
  iconSize: 'small',
};

export default ListCarousel;
